// extracted by mini-css-extract-plugin
export default {"section":"AboutSection_section__m6Btb"};